export default __webpack_public_path__ + "static/media/favicon.f5a34afc.ico";